__turbopack_context__.v({
  "hidden": "Feed-module-scss-module__ivt9uW__hidden",
  "stickyHeader": "Feed-module-scss-module__ivt9uW__stickyHeader",
  "triggerButton": "Feed-module-scss-module__ivt9uW__triggerButton",
});
